// removed by extract-text-webpack-plugin
module.exports = {"bannerHeader":"qempo_Banner_bannerHeader-d7rdm44","blue":"qempo_Banner_blue-3JmNlfV","grey":"qempo_Banner_grey-2ATSsPH","orange":"qempo_Banner_orange-2w5xlNO","white":"qempo_Banner_white-neTISe2","bannerContent":"qempo_Banner_bannerContent-2X6z9Xj","rightContent":"qempo_Banner_rightContent-6yt1kXU"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/Banner/Banner.scss
// module id = 1332
// module chunks = 0